
import {
  DASHBOARD_INCIDENT_MODAL_TOGGLE,
  SET_INCIDENT_MODAL_STATE,
  SET_THEME,
  SET_SIDEBAR_COLLAPSED,
  SET_RECENT_INCIDENTS_HISTORY,
  LOGOUT_MODAL_TOGGLE,
  DASHBOARD_NAME,
  SET_MEET_MODE,
  SET_INCIDENTS_DATAS,
} from '../ActionType/actionType';
 
 
export const setThemeToggle = (theme) =>  ({
  type: SET_THEME,
  payload: theme,
});
 
export const setIncidentModalState = (state) => ({
  type: SET_INCIDENT_MODAL_STATE,
  payload: state,
});

export const dashboardIncidentModalToggle = (isOpen) =>
  setIncidentModalState(isOpen ? 'open' : 'closed');

export const openIncidentModal = () => (dispatch, getState) => {
  const current = getState().organization.incidentModalState;
  if (current !== 'open') {
    dispatch(setIncidentModalState('open'));
  }
};

export const setSidebarCollapsed = (isCollapsed) => ({
  type: SET_SIDEBAR_COLLAPSED,
  payload: isCollapsed,
});

export const setRecentIncidentHistory = (incidents) => ({
  type: SET_RECENT_INCIDENTS_HISTORY,
  payload: incidents,
});

export const logoutModalToggle = (isOpen) => ({
  type: LOGOUT_MODAL_TOGGLE,
  payload: isOpen,
});

export const setDashboardName = (name) => ({
  type : DASHBOARD_NAME,
  payload : name
})

export const setMeetMode = (mode) => ({
  type : SET_MEET_MODE,
  payload : mode
})

export const setIncidentsDatas = (data) => ({
  type : SET_INCIDENTS_DATAS,
  payload : data
})
